<div class="wrapper">
  <div class="content">
    <div class="cards">
      <div class="card">
        <div class="card-title-row">
          <div class="card-title">Projects</div>
          <button class="add-btn" (click)="onAddProject()">Add</button>
        </div>
        <div class="list" *ngIf="projects$ | async as projects">
          <div
            *ngIf="newProjectMode"
            class="list-item"
            style="border: none !important; border-bottom: 1px solid black"
          >
            <div class="flex-row gap-8">
              <div class="avatar small"></div>
              <input
                #newProjectInput
                type="text"
                placeholder="Project name"
                [(ngModel)]="newProjectName"
                (keydown.enter)="submitNewProject()"
              />
            </div>
            <div class="flex-row gap-8">
              <nw-icon
                type="check"
                [size]="16"
                (click)="submitNewProject()"
              ></nw-icon>
              <nw-icon
                type="close"
                [size]="16"
                (click)="discardNewProject()"
              ></nw-icon>
            </div>
          </div>
          <ng-container *ngIf="projects.length; else noProjects">
            <div
              class="list-item"
              *ngFor="let p of projects"
              [routerLink]="['/p', p.id]"
            >
              <div class="flex-row gap-8">
                <div class="avatar small">{{ (p.name || '?')[0] }}</div>
                <div class="name">{{ p.name }}</div>
              </div>
            </div>
          </ng-container>
          <ng-template #noProjects>
            <div class="empty">No projects</div>
          </ng-template>
        </div>
      </div>
      <div class="card">
        <div class="card-title-row">
          <div class="card-title">Team</div>
          <button class="add-btn" (click)="onAddUser()">Add</button>
        </div>
        <div class="list" *ngIf="team$ | async as team; else noTeam">
          <div
            *ngIf="newUserMode"
            class="list-item"
            style="border: none !important; border-bottom: 1px solid black"
          >
            <div class="flex-row gap-8">
              <div class="avatar small"></div>
              <input
                #newUserInput
                type="text"
                placeholder="Email"
                [(ngModel)]="newUserEmail"
                (keydown.enter)="submitNewUser()"
              />
            </div>
            <div class="flex-row gap-8">
              <nw-loader [size]="16" *ngIf="newUserIsLoading$ | async">
              </nw-loader>
              <ng-container *ngIf="!(newUserIsLoading$ | async)">
                <nw-icon
                  type="check"
                  [size]="16"
                  (click)="submitNewUser()"
                ></nw-icon>
                <nw-icon
                  type="close"
                  [size]="16"
                  (click)="discardNewUser()"
                ></nw-icon>
              </ng-container>
            </div>
          </div>
          <div class="list-item" *ngFor="let u of team">
            <div>
              <div class="avatar small">
                {{ (u.firstName || getUserName(u))[0] }}
                {{ (u.lastName || '')[0] }}
              </div>
              <span class="name" style="margin-left: 8px">{{
                getUserName(u)
              }}</span>
            </div>
            <!-- <div class="name">{{ u.firstName }} {{ u.lastName }}</div> -->
          </div>
        </div>
        <ng-template #noTeam>
          <div class="empty">No team members</div>
        </ng-template>
      </div>
      <!-- Style card -->
      <div class="card" style="overflow: visible">
        <div class="card-title-row">
          <div class="card-title">Style</div>
        </div>
        <div class="style-content" *ngIf="currentOrg$ | async as org">
          <!-- Font Family inline edit -->
          <div class="style-row">
            <div class="style-label">Font Family</div>
            <nw-font-family-selector
              [fontFamily]="org.fontFamily || ''"
              [emitOnly]="true"
              (fontSelected)="onFontFamilyChange($event)"
            ></nw-font-family-selector>
          </div>

          <!-- Color Palette with preview circles -->
          <div class="style-row">
            <div class="style-label">Color Palette</div>
            <div
              class="color-palette-preview"
              *ngIf="org.colorPalette as palette"
            >
              <div
                class="color-circle"
                *ngFor="let entry of palette | keyvalue"
                [style.background-color]="entry.value"
                [title]="entry.key + ': ' + entry.value"
              ></div>
              <button class="edit-colors-btn" (click)="openColorPaletteModal()">
                Edit
              </button>
            </div>
            <div class="color-palette-preview" *ngIf="!org.colorPalette">
              <div class="empty">No colors</div>
              <button class="edit-colors-btn" (click)="openColorPaletteModal()">
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Color palette modal -->
  <div
    class="modal-overlay"
    *ngIf="showColorPaletteModal"
    (click)="closeColorPaletteModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Edit Color Palette</h3>
        <button class="close-btn" (click)="closeColorPaletteModal()">×</button>
      </div>
      <div class="modal-body">
        <div
          class="color-editor"
          *ngFor="let item of editingPaletteEntries; let i = index"
        >
          <input
            type="text"
            [(ngModel)]="editingPaletteEntries[i].key"
            placeholder="Color name"
          />
          <input type="color" [(ngModel)]="editingPaletteEntries[i].value" />
          <button class="remove-btn" (click)="removeColor(i)">Remove</button>
        </div>
        <button class="add-color-btn" (click)="addColor()">Add Color</button>
      </div>
      <div class="modal-footer">
        <button class="secondary" (click)="closeColorPaletteModal()">
          Cancel
        </button>
        <button class="primary" (click)="saveColorPalette()">Save</button>
      </div>
    </div>
  </div>
  <!-- Hidden portal for user-selector's new user panel overlay -->
</div>
